import React, { ReactChild } from 'react';

import LogoPicktow from '~/assets/png/logo_atise.png';

import { DivContainer, Div, Logo } from './styles';

export default function AuthLayout({ children }: { children: ReactChild }) {
  return (
    <DivContainer>
      <Div>
        <Logo src={LogoPicktow} />
        {children}
      </Div>
    </DivContainer>
  );
}
